import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class BigMushroom1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.BIG_MUSHROOM1;
}

export default BigMushroom1PoiTileEntity;
